/* global analytics */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { orderBy, sumBy, findIndex, find, get, every } from 'lodash';
import * as queryString from 'query-string';
import moment from 'moment';
import PropTypes from 'prop-types';

import { isLoginPopUpNeeded, userParams, titles } from '../../components/PopUps/LoginPopUpWrapper/LoginPopUp/utils';
import { WelcomePopUp } from '../../components/PopUps';
import AdminBar from '../../components/EventProfile/AdminBar';
import EventProfileHeader from '../../components/EventProfile/EventProfileHeader';
import PhotoEditor from '../../components/PhotoUpload/PhotoEditor';
import PlayersTabContent from '../../components/EventProfile/PlayersTabContent';
import RegConfirmation from '../../components/EventProfile/RegConfirmation';
import ShareUrlPopupNew from '../../components/PopUps/ShareUrlPopup';
import SideBar from '../../components/EventProfile/SideBar';
import StripeWithdrawModal from './StripeWithdrawModal';
import GenericPopup from '../../components/PopUps/GenericPopup';
import GenericPopupWithTwoButtons from '../../components/PopUps/GenericPopup/GenericPopupWithTwoButtons';
import head from '../../components/Meta';

import * as loginPopUpActions from '../../actions/login-popup-actions';
import * as messagingActions from '../../actions/messaging-actions';
import { getEvent, cropEventBanner, getRegPayments, showAdminSplash, selfWithdrawFromEvent } from '../../actions/event-actions';
import { uploadTempPhoto, clearTempPhoto } from '../../actions/upload-actions';
import { setDisableRangeSurveySkip, setSkipOnboardingIntroPopup } from '../../actions/onboarding-actions';

import { ConversationContextTypes, MemberContextTypes, getMemberEntityObject } from '../../utils/messaging';
import { getApiAxiosInstance } from '../../utils/network';
import { getEventReferralURL, getEventShareURL } from '../../utils/referrals';
import { isEventDirector, isEventParticipant, isOrganizer, PaidHitEventSelfWithdrawBeforeHours } from '../../utils/events';
import { EventProfileTabIdentifiers, nonPoweredPlayerDefaultDivisionFee } from '../../utils/constants';

import * as checkoutEventRegistrationApi from '../../api/checkoutEventRegistrationApi';
import config from '../../../config';
import styles from './event.scss';
import ConfirmActionPopup1Btn from '../../components/PopUps/ConfirmActionPopup1Btn';
import OverViewTabContent from '../../components/EventProfile/OverViewTabContent';

const _ = { orderBy, sumBy, findIndex, find, get, every };

function PaidHitProfilePage(props) {
    const {
        addMessageRecepient,
        auth,
        clearTemporaryPhoto,
        coreUI,
        cropBanner,
        events,
        getCurrentEvent,
        getRegistrationPayment,
        history,
        isNewMessageConversation,
        location,
        match,
        showLoginModal,
        showSplash,
        uploadPhoto,
        uploads,
        loginPopUp,
    } = props;
    const { currentEvent } = events;
    const { regPaymentRefund, data: event, playersTabState } = currentEvent;
    const bannerImage = event?.photoUrl || null;
    // const eventInviteUrl = event && auth.user ? getEventReferralURL(event, auth.user) : getEventShareURL(event);
    const eventInviteUrl = getEventShareURL(event);
    const isCurrentMemberAdmin = event && isOrganizer(event);
    const eventVerificationFeeParsed = event && parseFloat(event.verificationFee);
    const clubVerificationFee = eventVerificationFeeParsed >= 0 ? eventVerificationFeeParsed : nonPoweredPlayerDefaultDivisionFee;

    const [isCollapsed, setIsCollapsed] = useState(false);
    const [isRegistering, setIsRegistering] = useState(false);
    const [isRegistrationConfirmed, setIsRegistrationConfirmed] = useState(false);
    const [isSideBarOpen, setIsSidebarOpen] = useState(false);
    const [showPhotoEditor, setShowPhotoEditor] = useState(false);
    const [showRefundSuccess, setShowRefundSuccess] = useState(false);
    const [showShareUrlPopup, setShowShareUrlPopup] = useState(false);
    const [showStripeWithdrawPopup, setShowStripeWithdrawPopup] = useState(false);
    const [playerToWithdraw, setPlayerToWithdraw] = useState(null);
    const [tabs, setTabs] = useState([
        {
            id: EventProfileTabIdentifiers.OVERVIEW,
            title: 'Overview',
            needsLogin: false,
            active: true,
            showTab: true,
        },
        {
            id: EventProfileTabIdentifiers.PLAYERS,
            title: 'Players',
            needsLogin: true,
            showTab: isCurrentMemberAdmin,
            active: false,
        },
    ]);
    const [showSelfPlayerWithdrawPopup, setShowSelfPlayerWithdrawPopup] = useState(false);
    const [showSelfPlayerCanNotWithdrawPopup, setShowSelfPlayerCanNotWithdrawPopup] = useState(false);
    const [parentGuardianPopup, setParentGuardianPopup] = useState(false);
    const [utrRangePopup, setUtrRangePopup] = useState(false);

    const activeTab = _.find(tabs, { active: true });

    const updateQueryParam = (param, value) => {
        const parsed = queryString.parse(location.search);
        parsed[param] = value;
        history.replace({
            search: queryString.stringify(parsed),
        });
    };

    const startRegistration = () => {
        setIsRegistering(false);
        setIsSidebarOpen(true);
    };

    const toRegistration = () => {
        const isUserRegisteredForEvent = event.registered;
        if (isUserRegisteredForEvent) {
            const diffInHours = moment.utc(event.eventSchedule.eventStartUtc).diff(moment.utc(), 'hours');
            if (diffInHours >= PaidHitEventSelfWithdrawBeforeHours) {
                setShowSelfPlayerWithdrawPopup(true);
                setShowSelfPlayerCanNotWithdrawPopup(false);
            } else {
                setShowSelfPlayerWithdrawPopup(false);
                setShowSelfPlayerCanNotWithdrawPopup(true);
            }
        } else {
            setIsRegistering(true);
        }
    };

    const handleOnRegisterClicked = () => {
        const { birthdate, secondaryEmail, isSecondaryEmailVerified, utrRangeRequired } = auth.user || {};
        const userAge = moment().diff(birthdate, 'years');

        if (userAge < 18 && !(secondaryEmail && isSecondaryEmailVerified)) {
            setParentGuardianPopup(true);
        } else if (auth.user?.claimedPlayer && utrRangeRequired) {
            setUtrRangePopup(true);
        } else {
            toRegistration();
        }
    };

    const handleOnTabClicked = (e, selectedTabId) => {
        updateQueryParam('t', selectedTabId);
        const updatedTabs = tabs.map((tab) => ({ ...tab, active: selectedTabId === tab.id }));
        setTabs(updatedTabs);
    };

    useEffect(() => {
        if (loginPopUp.showPopUp === false) {
            setIsRegistering(false);
        }
    }, [loginPopUp.showPopUp]);

    useEffect(() => {
        const { shared } = queryString.parse(window.location.search);
        const userParamsNeeded = [userParams.CLAIMED_PROFILE];
        const isLoginPopupNeeded = isLoginPopUpNeeded(auth, userParamsNeeded);
        const popupData = {
            userParamsNeeded,
            titles: titles.EVENT_REGISTER,
            type: 'register',
        };
        if ((isRegistering && !auth.user) || (isRegistering && auth.user && isLoginPopupNeeded) || (shared && !auth.user)) {
            showLoginModal(popupData);
        } else if (isRegistering && auth.user) {
            startRegistration();
        }
    }, [isRegistering, auth]);

    useEffect(() => {
        const parsed = queryString.parse(location.search);

        if (event?.wasUpdated && location.state?.adminSplash) {
            showSplash(location.state.adminSplash);
        }

        if (events?.currentEvent.error) {
            if (events.currentEvent.redirectUrl) {
                history.push(events.currentEvent.redirectUrl);
            } else {
                history.push('/');
            }
        }

        setTabs([
            {
                id: EventProfileTabIdentifiers.OVERVIEW,
                title: 'Overview',
                needsLogin: false,
                active: !parsed.t || parseInt(parsed.t) === EventProfileTabIdentifiers.OVERVIEW,
                showTab: true,
            },
            {
                id: EventProfileTabIdentifiers.PLAYERS,
                title: 'Players',
                needsLogin: true,
                active: parseInt(parsed.t) === EventProfileTabIdentifiers.PLAYERS,
                showTab: isCurrentMemberAdmin,
            },
        ]);
    }, [event]);

    const clearWithdrawnPlayer = () => {
        setPlayerToWithdraw(null);
    };

    const handleOnBackToEvent = () => {
        setIsCollapsed(false);
        setIsRegistrationConfirmed(false);
        getCurrentEvent(match.params.eventId);
    };

    const handleOnRequestCloseStripeModal = () => {
        setShowStripeWithdrawPopup(false);
    };

    const handleOnRequestCloseShareModal = () => {
        setShowShareUrlPopup(false);
    };

    const handleOnCroppedPhotoSaved = async (values) => {
        const { id } = events.currentEvent.data;
        await cropBanner(id, values);
        clearTemporaryPhoto(true);
        setShowPhotoEditor(false);
    };

    const handleOnRequestClosePhotoEditor = () => {
        setShowPhotoEditor(false);
        clearTemporaryPhoto(true);
    };

    const handleOnOverlayClick = () => {
        if (isSideBarOpen) {
            setIsSidebarOpen(false);
        }
    };

    const handleOnUploadPhoto = (file) => {
        uploadPhoto(file);
    };

    const handleOnShowPhotEditor = () => {
        setShowPhotoEditor(true);
    };

    const handleOnWithdrawPlayerConfirmed = async (partialWithdrawRequest) => {
        try {
            await checkoutEventRegistrationApi.partialWithdrawPlayerFromEvent(getApiAxiosInstance(), event.id, partialWithdrawRequest);

            if (partialWithdrawRequest.refundRequest.divisionIds.length) {
                setShowRefundSuccess(true);
            }

            await getCurrentEvent(match.params.eventId);
            clearWithdrawnPlayer();
        } catch (e) {
            console.log('Error Withdrawing player');
        }
    };

    const handleOnManagePlayerSelected = (e, playerId, selected) => {
        const PAYMENT_PROVIDER_TYPE_STRIPE = 2;
        if (selected.value === 'withdraw') {
            const playerToBeWithdrawn = _.find(event.registeredPlayers, { id: playerId });
            if (playerToBeWithdrawn) {
                if (event?.paymentProviderType?.id === PAYMENT_PROVIDER_TYPE_STRIPE) {
                    getRegistrationPayment({ eventId: event.id, memberId: playerToBeWithdrawn.memberId });
                    setShowStripeWithdrawPopup(true);
                    setPlayerToWithdraw(playerToBeWithdrawn);
                }
            }
        } else if (selected.value === 'refund') {
            let playerToBeRefunded = null;
            switch (playersTabState.selectedStatus.value) {
                case 'registered':
                    playerToBeRefunded = _.find(event.registeredPlayers, { id: playerId });
                    break;
                case 'withdrawn':
                    playerToBeRefunded = _.find(event.withdrawnPlayers, { id: playerId });
                    break;
                default:
                    break;
            }

            if (playerToBeRefunded) {
                if (event?.paymentProviderType?.id === PAYMENT_PROVIDER_TYPE_STRIPE) {
                    getRegistrationPayment({ eventId: event.id, memberId: playerToBeRefunded.memberId });
                    setShowStripeWithdrawPopup(true);
                    setPlayerToWithdraw(playerToBeRefunded);
                }
            }
        }
    };

    const sendMessageToUser = async (recipient) => {
        // for free users do the preflight check
        if (recipient?.memberId && event) {
            const conversation = {
                entities: [],
            };
            conversation.originatingContext = _.find(coreUI.types.messagingConversationContextType, { id: ConversationContextTypes.EVENT_PROFILE }).value;
            conversation.originatingContextId = event.id;

            // Add sender entities
            const senderContexttype = isEventDirector(event, auth.user.id)
                ? MemberContextTypes.EVENT_ORGANIZER
                : isEventParticipant(event, auth.user.id) ? MemberContextTypes.EVENT_PARTCIPANT : MemberContextTypes.PLAYER;
            conversation.entities.push(getMemberEntityObject(coreUI.types, auth.user.id, senderContexttype));

            // Add reciepient entities
            const reciepientContexttype = isEventDirector(event, recipient.memberId)
                ? MemberContextTypes.EVENT_ORGANIZER
                : isEventParticipant(event, recipient.memberId) ? MemberContextTypes.EVENT_PARTCIPANT : MemberContextTypes.PLAYER;
            conversation.entities.push(getMemberEntityObject(coreUI.types, recipient.memberId, reciepientContexttype));

            isNewMessageConversation(true);
            addMessageRecepient(recipient);
            history.push(`/inbox`);
        }
    };

    const sendMessage = async (recipient) => {
        if (auth.user.isPowered || recipient.isPaidHitter || recipient.eventDirectorRole?.value === 'owner' || recipient.eventDirectorRole?.value === 'admin') {
            sendMessageToUser(recipient);
        }
    };

    const handleOnShowSharePopup = () => {
        setShowShareUrlPopup(true);
    };

    const handleOnRegistrationConfirmed = () => {
        const deactivedTabs = tabs.map((tab) => ({ ...tab, active: false }));
        setTabs(deactivedTabs);
        setIsCollapsed(true);
        setIsRegistrationConfirmed(true);
        setIsSidebarOpen(false);
    };

    const handleOnLinkCopied = () => {
        if (window && window.analytics) {
            const path = '/share/event';
            const properties = {
                path,
                url: path,
                name: events.currentEvent.data.name,
            };

            analytics.page('share event profile', 'share link', properties);
        }
    };

    const handleOnSelfPlayerWithdrawPopupClose = () => {
        setShowSelfPlayerWithdrawPopup(false);
        setShowSelfPlayerCanNotWithdrawPopup(false);
    };

    const handleOnSelfPlayerWithdrawPopupMessage = () => {
        handleOnSelfPlayerWithdrawPopupClose();

        const eventDirector = event.eventDirectors?.length > 0 && event.eventDirectors[0];
        if (eventDirector) {
            sendMessage(eventDirector);
        }
    };

    const handleOnSelfPlayerWithdrawPopupConfirmWithdraw = () => {
        handleOnSelfPlayerWithdrawPopupClose();

        const withdrawPayload = {
            userId: auth.user.id,
            divisionIds: event.eventDivisions.filter(ed => ed.registered).map(ed => ed.id),
            eventId: event.id,
        };

        props.selfWithdrawFromEvent(withdrawPayload);
    };

    const redirectToUtrRangeSurvey = () => {
        props.setDisableRangeSurveySkip(true);
        props.setSkipOnboardingIntroPopup(true);
        props.history.push(`/onboarding-survey?return=/events/${event.id}`);
    };

    return event ? (
        <div>
            {head({
                title: currentEvent.data?.name ? `UTR Sports | ${currentEvent.data?.name}` : config.defaultTitle,
                description: currentEvent.data?.details,
                url: `${config.appHost}/events/${currentEvent.data?.id}`,
                keywords: 'UTR Sports events, Find UTR Sports tennis events, UTR post score',
                image: `https://www.${config.siteBaseUrl}/img/utr_sports/utr-sports-logo.svg`,
                imageWidth: '930',
                imageHeight: '395',
            })}
            {(event && !events.isLoading) && (
                <React.Fragment>
                    {isSideBarOpen && (
                        <SideBar
                            auth={auth}
                            event={event}
                            sidebarOpen={isSideBarOpen}
                            handleOverlayClick={handleOnOverlayClick}
                            toRegConfirmation={handleOnRegistrationConfirmed}
                        />
                    )}
                    {isCurrentMemberAdmin &&
                    <AdminBar />}
                    <EventProfileHeader
                        isCurrentMemberAdmin={isCurrentMemberAdmin}
                        collapsed={isCollapsed}
                        bannerImage={bannerImage}
                        clubVerificationFee={clubVerificationFee}
                        tabs={tabs}
                        handleRegClick={handleOnRegisterClicked}
                        handleTabClick={handleOnTabClicked}
                        handleUploadPhoto={handleOnUploadPhoto}
                        handleUploadPhotoStart={handleOnShowPhotEditor}
                        showShareUrlPopup={handleOnShowSharePopup}
                        coreUI={coreUI}
                    />
                    <div className={`${styles.section} bg-transparent main-content`}>
                        <div className={`container bg-transparent`}>
                            <div className="row">
                                <div className="col">
                                    <div className={activeTab?.id === EventProfileTabIdentifiers.OVERVIEW ? 'd-block' : 'd-none'}>
                                        <OverViewTabContent
                                            clubVerificationFee={clubVerificationFee}
                                            isCurrentMemberAdmin={isCurrentMemberAdmin}
                                            sendMessage={sendMessage}
                                            coreUI={coreUI}
                                            showEventPhoneAndEmail={false}
                                        />
                                    </div>
                                    <div className={activeTab?.id === EventProfileTabIdentifiers.PLAYERS ? 'd-block' : 'd-none'}>
                                        <PlayersTabContent
                                            isCurrentMemberAdmin={isCurrentMemberAdmin}
                                            playerMenuOnSelected={handleOnManagePlayerSelected}
                                            sendMessage={sendMessage}
                                            data-testid="paid-hit-profile.players-content"
                                        />
                                    </div>
                                    <div className={isCollapsed && isRegistrationConfirmed ? 'd-block' : 'd-none'}>
                                        <RegConfirmation backToEvent={handleOnBackToEvent} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {showRefundSuccess && (
                        <WelcomePopUp
                            popupClass="popup-sm"
                            welcomeTitles={{
                                title: 'Refund Successful',
                                description: 'The refund will be processed within 24-48 hours.',
                            }}
                            onCloseClick={() => {
                                setShowRefundSuccess(false);
                            }}
                            onCtaClick={() => {
                                setShowRefundSuccess(false);
                            }}
                        />
                    )}
                </React.Fragment>
            )}
            {(isCurrentMemberAdmin) && (
                <PhotoEditor
                    showEditor={showPhotoEditor}
                    closeEditor={handleOnRequestClosePhotoEditor}
                    imageUrl={uploads.tempPhotoUrl}
                    uploadCropData={handleOnCroppedPhotoSaved}
                    type={'event_banner'}
                    data-testid="modal.paid-hit-profile.photo-editor"
                />
            )}
            {showShareUrlPopup && (
                <ShareUrlPopupNew
                    title={'Spread the word'}
                    subtitle={'Copy & share the link w/anyone'}
                    text={'Event Invite Link'}
                    url={`${eventInviteUrl}`}
                    hideButton={true}
                    isDraft={false}
                    closeBtnTxt={`Invite Club Members`}
                    onCloseClick={handleOnRequestCloseShareModal}
                    linkCopied={handleOnLinkCopied}
                />
            )}
            {showStripeWithdrawPopup && playerToWithdraw && (
                <StripeWithdrawModal
                    onCloseClick={handleOnRequestCloseStripeModal}
                    withdrawPlayer={playerToWithdraw}
                    divisions={(event?.eventDivisions) || []}
                    currency={(event?.currency) || {}}
                    regPaymentRefund={regPaymentRefund || {}}
                    confirmPopup={handleOnWithdrawPlayerConfirmed}
                    event={event}
                />
            )}
            {showSelfPlayerWithdrawPopup && (
                <GenericPopupWithTwoButtons
                    data-testid="modal.paid-hit-profile.withdraw-confirmation"
                    title={'Edit Registration'}
                    subtitle={(
                        <div className="text-left">
                            <div>If you want to request a change to paid hit date or time you can message the paid hitter.</div>
                            <div className="mt16">You can cancel the paid hit with a full refund because there are more than 48 hours to go before your Paid Hit.</div>
                        </div>
                    )}
                    primaryButtonText="Message"
                    secondaryButtonText="Cancel Paid Hit"
                    secondaryButtonType="btn-primary"
                    onRequestClose={handleOnSelfPlayerWithdrawPopupClose}
                    onPrimaryButtonClick={handleOnSelfPlayerWithdrawPopupMessage}
                    onSecondaryButtonClick={handleOnSelfPlayerWithdrawPopupConfirmWithdraw}
                />
            )}
            {showSelfPlayerCanNotWithdrawPopup && (
                <GenericPopup
                    title={'Edit Registration'}
                    data-testid="modal.paid-hit-profile.cannot-withdraw"
                    subtitle={(
                        <div className="text-left">
                            <div>If you want to request a change to paid hit date or time you can message the paid hitter.</div>
                            <div className="mt16">
                                You cannot cancel and get a refund because there are less than 48 hours to go before your Paid Hit.
                                If you cannot make the Paid hit you can message the Paid Hitter to see if you can change the date or time or just have them take you off the event.
                            </div>
                        </div>
                    )}
                    buttonText={'Message'}
                    onRequestClose={handleOnSelfPlayerWithdrawPopupClose}
                    onButtonClick={handleOnSelfPlayerWithdrawPopupMessage}
                />
            )}
            {parentGuardianPopup && (
                <ConfirmActionPopup1Btn
                    onCloseClick={() => setParentGuardianPopup(false)}
                    onCtaClick={() => props.history.push('/settings/account')}
                    confirmationTitle={`Add Parent/Guardian email address`}
                    confirmationMessage={`To register for a paid hit, please add an email address of your parent or guardian. Once it is verified you can register for the event. You can add this email from your user settings, in the 'Parent/Guardian Email' field.`}
                    confirmButtonLabel={`Add Parent or Guardian Email`}
                />
            )}
            {utrRangePopup && (
                <ConfirmActionPopup1Btn
                    onCloseClick={() => setUtrRangePopup(false)}
                    onCtaClick={redirectToUtrRangeSurvey}
                    confirmationTitle={`Get your UTR Rating started`}
                    confirmationMessage={`We need a little information to get your UTR Rating estimated. It's the first step to enjoying more level-based play. Your coach or club needs this to match you up for this event (required)`}
                    confirmButtonLabel={`Next`}
                />
            )}
        </div>
    ) : null;
}

function mapDispatchToProps(dispatch) {
    return {
        clearTemporaryPhoto: usePng => dispatch(clearTempPhoto(usePng)),
        cropBanner: (eventId, values) => dispatch(cropEventBanner(eventId, values)),
        getCurrentEvent: (eventId) => dispatch(getEvent(eventId, false, false, false)),
        getRegistrationPayment: ({ eventId, memberId }) => dispatch(getRegPayments({ eventId, memberId })),
        addMessageRecepient: member => dispatch(messagingActions.addRecepient({ member })),
        isNewMessageConversation: member => dispatch(messagingActions.setNewConv({ member })),
        showSplash: data => dispatch(showAdminSplash(data)),
        showLoginModal: data => dispatch(loginPopUpActions.showLoginPopUp(data)),
        uploadPhoto: file => dispatch(uploadTempPhoto(file)),
        selfWithdrawFromEvent: data => dispatch(selfWithdrawFromEvent(data)),
        setDisableRangeSurveySkip: bool => dispatch(setDisableRangeSurveySkip(bool)),
        setSkipOnboardingIntroPopup: bool => dispatch(setSkipOnboardingIntroPopup(bool)),
    };
}

function mapStateToProps({ auth, search, events, uploads, coreUI, loginPopUp }) {
    return { auth, search, events, uploads, coreUI, loginPopUp };
}

PaidHitProfilePage.propTypes = {
    auth: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaidHitProfilePage);
